export default __webpack_public_path__ + "static/media/WSC_Logo_White_png.73f534d6.png";